/* initiate tooltips across page */
var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
  return new bootstrap.Tooltip(tooltipTriggerEl)
});

/* refresh Slick slider on open of collapse element */
var collapseTriggerList = [].slice.call(document.querySelectorAll('.accordion-collapse'))
var collapseList = collapseTriggerList.map(function (collapseEle) {
   collapseEle.addEventListener('show.bs.collapse', event => {
     jQuery(event.target).find(".slick-slider").slick("refresh");
   })
});

/* Initiate sliders */
jQuery('[data-slider-display]').each(function () {
  var $el = jQuery(this);
  var carouselDisplayType = $el.data('slider-display');

  if (carouselDisplayType === 'all' || (carouselDisplayType === 'mobile' && window.innerWidth < Shopify.mobile_breakpoint)) {
    if (!$el.hasClass('slick-initialized')) {
      var rotate = $el.data('slider-rotate');

      $el.slick({
        slidesToShow: $el.data('slider-slides'),
        slidesToScroll: 1,
        arrows: $el.data('slider-arrows'),
        dots: $el.data('slider-dots'),
        infinite: $el.data('slider-infinite'),
        autoplay: rotate > 0,
        autoplaySpeed: rotate > 0 ? rotate * 1000 : 0,
        responsive: [
          {
            breakpoint: Shopify.mobile_breakpoint,
            settings: {
              slidesToShow: 1
            }
          }
        ]
      });
    }
  }
});

/* Enable 'view more' on collection sections */
jQuery('.collection .product-grid').each(function() {
  var items_to_show = parseInt(jQuery(this).data('list-limit')); // index starts at zero
  var total_items = jQuery(this).find('> div').length;
  var view_more_button = jQuery(this).parent().find('.view-more-button:not([href])');
  
  if( items_to_show < total_items && view_more_button.length > 1 ) {
    items_to_show = items_to_show - 1;
    view_more_button.show();
    jQuery(this).find('> div:gt('+items_to_show+')').hide();
    jQuery(this).show();
    
    view_more_button.click(function () {
      var list_target = '.grid-'+jQuery(this).data('list-id');
      jQuery(list_target+' div').show();
      jQuery(this).hide();
    });
  };
});

/* NAVIGATION */
if( window.innerWidth > Shopify.mobile_breakpoint ) {
  jQuery(".navbar-nav.tier-1 > .dropdown").hover(
    function(){ jQuery(".navbar-nav.tier-1 .dropdown").removeClass('open'); jQuery(this).addClass('open'); jQuery('main').prepend('<div class="mainNavOverlay"></div>'); },
    function(){ jQuery(this).removeClass('open'); jQuery('div.mainNavOverlay').not('.cart').remove(); }
  );
  jQuery(".dropdown-toggle").click( function() {
    window.location = jQuery(this).attr('href');
  });

} else {
  var menu = jQuery('.navbar-nav.tier-1');

  jQuery('.navbar-toggler').on('click', function (evt) {
    menu.removeClass('open');
    menu.find('.dropdown.open').removeClass('open');
  });

  jQuery('.navbar-nav.tier-1 > .dropdown > .dropdown-toggle').on('click', function (evt) {
    if( jQuery(this).siblings().length ) {
      evt.preventDefault();
      if( parseInt(menu.css('left')) == 0 ) { 
        jQuery(this).parent().toggleClass('open');
        menu.addClass('open');
      };
    };
  });

  jQuery('.navbar-nav.tier-2 > .dropdown').on('click', function () {
    jQuery(this).siblings().removeClass('open');
    jQuery(this).toggleClass('open');
  });

  jQuery('a.menu-back').on('click', function () { 
    menu.removeClass('open');
    menu.find('.dropdown.open').removeClass('open');
    jQuery(this).parent().parent().focusout();
  });

} // if( parseInt(jQuery(window).width()) > 768 )
/* END NAVIGATION */